import React, {Suspense, lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import DashboardWrapper from '../pages/dashboard/DashboardWrapper'

export function PrivateRoutes() {
  const UsersPage = lazy(() => import('../modules/users/Users'))
  const TeamsPage = lazy(() => import('../modules/teams/Teams'))
  const InvitesPage = lazy(() => import('../modules/invites/Invites'))
  const MyDaysPage = lazy(() => import('../modules/my-day/MyDays'))
  const SiteTypesPage = lazy(() => import('../modules/site-types/SiteTypes'))
  const SitesPage = lazy(() => import('../modules/sites/Sites'))
  const FloorsPage = lazy(() => import('../modules/floors/Floors'))
  const CheckInStrategiesPage = lazy(
    () => import('../modules/checkin-strategies/CheckInStrategies')
  )
  const AssetTypesPage = lazy(() => import('../modules/asset-types/AssetTypes'))
  const AllocationsPage = lazy(() => import('../modules/allocations/Allocations'))
  const AssetsPage = lazy(() => import('../modules/assets/Assets'))
  const RolesPage = lazy(() => import('../modules/roles/Roles'))
  const NotWorkingReasonsPage = lazy(
    () => import('../modules/not-working-reason/NotWorkingReasons')
  )
  const OffSiteReasonsPage = lazy(() => import('../modules/off-site-reason/OffSiteReasons'))
  const ConnectsPage = lazy(() => import('../modules/connects/Connects'))
  const ProjectsPage = lazy(() => import('../modules/projects/Projects'))
  const ProjectRolesPage = lazy(() => import('../modules/project-roles/ProjectRoles'))
  const BusinessUnitsPage = lazy(() => import('../modules/business-unit/BusinessUnit'))
  const AccountPage = lazy(() => import('../modules/account/Account'))
  const PlannersPage = lazy(() => import('../modules/planner/Planners'))
  const NeighborhoodsPage = lazy(() => import('../modules/neighborhoods/Neighborhoods'))
  const AttributesPage = lazy(() => import('../modules/attributes/Attributes'))

  const Messages = lazy(() => import('../modules/messages/Messages'))
  const Charts = lazy(() => import('../modules/charts/Charts'))
  const UserType = lazy(() => import('../modules/user-types/UserType'))
  const ActivityFeeds = lazy(() => import('../modules/activity-feeds/ActivityFeeds'))
  const Notifications = lazy(() => import('../modules/notifications/Notifications'))
  const DaysieNotifications = lazy(
    () => import('../modules/daysie-notifications/DaysieNotifications')
  )
  const Holidays = lazy(() => import('../modules/holidays/Holidays'))
  const Bookings = lazy(() => import('../modules/bookings/Bookings'))
  const AccountThemes = lazy(() => import('../modules/account-themes/AccountThemes'))
  const Localizations = lazy(() => import('../modules/account-themes/Localizations'))
  const Events = lazy(() => import('../modules/events/Events'))
  const Reports = lazy(() => import('../modules/reports/Reports'))
  const UserSkills = lazy(() => import('../modules/user-attributes/UserSkills'))
  const NoticeTypes = lazy(() => import('../modules/notice-types/NoticeTypes'))
  const Notices = lazy(() => import('../modules/notices/Notices'))
  const HealthSafety = lazy(() => import('../modules/health-safety/HealthSafety'))
  const CafeProducts = lazy(() => import('../modules/cafe-products/CafeProducts'))
  const CafeProductTypes = lazy(() => import('../modules/cafe-product-types/CafeProductTypes'))
  const CafeProductOptions = lazy(
    () => import('../modules/cafe-product-options/CafeProductOptions')
  )
  const CafeOptionItems = lazy(() => import('../modules/cafe-option-items/CafeOptionItems'))
  const CafeOrders = lazy(() => import('../modules/cafe-orders/CafeOrders'))
  const Lockers = lazy(() => import('../modules/lockers/Lockers'))
  const Automations = lazy(() => import('../modules/automations/Automations'))
  const Vehicles = lazy(() => import('../modules/vehicles/Vehicles'))
  const Slots = lazy(() => import('../modules/slots/Slots'))
  const ParkingBookings = lazy(() => import('../modules/parking-bookings/ParkingBookings'))
  const CarParks = lazy(() => import('../modules/car-parks/CarParks'))
  const ReleaseReasons = lazy(() => import('../modules/release-reason/ReleaseReasons'))
  const SiteDashboard = lazy(() => import('../modules/site-dashboard/SiteDashboard'))
  const SiteOverview = lazy(() => import('../modules/site-overview/SiteOverview'))
  const TicketTypes = lazy(() => import('../modules/ticket-types/TicketType'))
  const TicketStandardStatuses = lazy(
    () => import('../modules/ticket-standard-statuses/TicketStandardStatuses')
  )
  const TicketPriorities = lazy(() => import('../modules/ticket-priorities/TicketPriorities'))
  const Tickets = lazy(() => import('../modules/tickets/Tickets'))
  const Parcels = lazy(() => import('../modules/parcels/Parcels'))
  const ParcelTypes = lazy(() => import('../modules/parcel-types/ParcelType'))
  const Courier = lazy(() => import('../modules/couriers/Couriers'))
  const ParcelLocations = lazy(() => import('../modules/parcel-locations/ParcelLocation')) //
  const ManagedEventCaterings = lazy(
    () => import('../modules/managed-event-caterings/ManagedEventCaterings')
  )
  const ManagedEventEquipments = lazy(
    () => import('../modules/managed-event-equipments/ManagedEventEquipments')
  )
  const ManagedEventLocations = lazy(
    () => import('../modules/managed-event-locations/ManagedEventLocations')
  )
  const ManagedEventRoomSetUps = lazy(
    () => import('../modules/managed-event-room-setups/ManagedEventRoomSetUps')
  )
  const ManagedEventCostCenters = lazy(
    () => import('../modules/managed-event-cost-centers/ManagedEventCostCenters')
  )
  const ManagedEvents = lazy(() => import('../modules/managed-events/ManagedEvents'))
  const DeskworksGateway = lazy(() => import('../modules/deskworks-gateway/Gateway'))
  const DeskworksControllerColors = lazy(
    () => import('../modules/deskworks-controllercolors/ControllerColors')
  )

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        {/* <Route path='/dashboard' component={DashboardWrapper} /> */}
        <Route path='/users' component={UsersPage} />
        <Route path='/teams' component={TeamsPage} />
        <Route path='/invites' component={InvitesPage} />
        <Route path='/site-types' component={SiteTypesPage} />
        <Route path='/checkin-strategies' component={CheckInStrategiesPage} />
        <Route path='/asset-types' component={AssetTypesPage} />
        <Route path='/allocations' component={AllocationsPage} />
        <Route path='/assets' component={AssetsPage} />
        <Route path='/day-plans' component={MyDaysPage} />
        <Route path='/sites' component={SitesPage} />
        <Route path='/floors' component={FloorsPage} />
        <Route path='/roles' component={RolesPage} />
        <Route path='/not-working-reasons' component={NotWorkingReasonsPage} />
        <Route path='/off-site-reasons' component={OffSiteReasonsPage} />
        <Route path='/connects' component={ConnectsPage} />
        <Route path='/projects' component={ProjectsPage} />
        <Route path='/project-roles' component={ProjectRolesPage} />
        <Route path='/business-functions' component={BusinessUnitsPage} />
        <Route path='/account' component={AccountPage} />
        <Route path='/planners' component={PlannersPage} />
        <Route path='/zones' component={NeighborhoodsPage} />
        <Route path='/attributes' component={AttributesPage} />
        <Route path='/messages' component={Messages} />
        <Route path='/charts' component={Charts} />
        <Route path='/user-types' component={UserType} />
        <Route path='/activity-feeds' component={ActivityFeeds} />
        <Route path='/notifications' component={Notifications} />
        <Route path='/daysie-notifications' component={DaysieNotifications} />
        <Route path='/holidays' component={Holidays} />
        <Route path='/bookings' component={Bookings} />
        <Route path='/themes/color' component={AccountThemes} />
        <Route path='/themes/localization' component={Localizations} />
        <Route path='/events' component={Events} />
        <Route path='/reports/activity' component={Reports} />
        <Route path='/reports/occupancy' component={Reports} />
        <Route path='/reports/asset-usage' component={Reports} />
        <Route path='/reports/assets-roll-up' component={Reports} />
        <Route path='/reports/occupancy-v2' component={Reports} />
        <Route path='/user-skills' component={UserSkills} />
        <Route path='/notice-types' component={NoticeTypes} />
        <Route path='/notices' component={Notices} />
        <Route path='/health-safety' component={HealthSafety} />
        <Route path='/cafe/products' component={CafeProducts} />
        <Route path='/cafe/product-types' component={CafeProductTypes} />
        <Route path='/cafe/product-options' component={CafeProductOptions} />
        <Route path='/cafe/option-items' component={CafeOptionItems} />
        <Route path='/cafe/orders' component={CafeOrders} />
        <Route path='/automations' component={Automations} />
        <Route path='/vehicles' component={Vehicles} />
        <Route path='/slots' component={Slots} />
        <Route path='/parking-bookings' component={ParkingBookings} />
        <Route path='/car-parks' component={CarParks} />
        <Route path='/release-reasons' component={ReleaseReasons} />
        <Route path='/site-dashboard' component={SiteDashboard} />
        <Route path='/site-overview' component={SiteOverview} />
        <Route path='/ticket-types' component={TicketTypes} />
        <Route path='/ticket-standard-statuses' component={TicketStandardStatuses} />
        <Route path='/ticket-priorities' component={TicketPriorities} />
        <Route path='/tickets' component={Tickets} />
        <Route path='/parcels' component={Parcels} />
        <Route path='/parcel-types' component={ParcelTypes} />
        <Route path='/couriers' component={Courier} />
        <Route path='/locker-loctions' component={Lockers} />
        <Route path='/parcel-locations' component={ParcelLocations} />
        <Route path='/managed-events/caterings' component={ManagedEventCaterings} />
        <Route path='/managed-events/equipments' component={ManagedEventEquipments} />
        <Route path='/managed-events/locations' component={ManagedEventLocations} />
        <Route path='/managed-events/room-setups' component={ManagedEventRoomSetUps} />
        <Route path='/managed-events/cost-centers' component={ManagedEventCostCenters} />
        <Route path='/managed-events' component={ManagedEvents} />
        <Route path='/deskworks-gateway' component={DeskworksGateway} />
        <Route path='/deskworks-controllercolors' component={DeskworksControllerColors} />
      </Switch>
    </Suspense>
  )
}
